export default __webpack_public_path__ + "static/media/tip3Wrong.fabfe795.svg";